import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import React, { useEffect } from "react";

import CloseDialogItemIcon from "../../../../../common/components/icons/CloseCrossIcon";
import { TOP_BAR_HEIGHT } from "../../../../../common/components/layout/MenuItem";
import { Z_INDEX_PRIORITY } from "../../../../../common/variables/common";

type DraggedModalBodyProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title: string;
  persistId: string;
  width?: number | string;
  height?: number | string;
};

// type Pos = { x: number; y: number };

// const STORAGE_PREFIX = "drag-modal-pos:";

// function loadPos(key: string): Pos {
//   try {
//     const raw = localStorage.getItem(STORAGE_PREFIX + key);

//     if (!raw) return { x: 0, y: 0 };

//     const obj = JSON.parse(raw);

//     if (typeof obj?.x === "number" && typeof obj?.y === "number") {
//       return obj as Pos;
//     }

//     return { x: 0, y: 0 };
//   } catch {
//     return { x: 0, y: 0 };
//   }
// }

// function savePos(key: string, pos: Pos) {
//   try {
//     localStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(pos));
//   } catch {
//     console.error("savePos error", key, pos);
//   }
// }

const DraggedModalBody: React.FC<DraggedModalBodyProps> = ({
  open,
  children,
  onClose,
  title,
  // persistId,
  width,
  height,
}) => {
  const theme = useTheme();
  // const storageKey = persistId;

  // const initialPos = useMemo(() => loadPos(storageKey), [storageKey, open]);

  useEffect(() => {
    return () => {
      onClose();
    };
  }, []);

  // PaperComponent is used to make the dialog draggable, but there is issues with fullscreen support due to transforms
  // const PaperComponent = (props: PaperProps) => {
  //   const nodeRef = useRef<HTMLDivElement>(null);

  //   return (
  //     <Draggable
  //       nodeRef={nodeRef}
  //       handle="#model-alerting-dialog-title"
  //       cancel={
  //         '[class*="MuiDialogContent-root"], [class*="MuiButtonBase-root"]'
  //       }
  //       bounds="body"
  //       defaultPosition={initialPos}
  //       onStop={(_, data) => savePos(storageKey, { x: data.x, y: data.y })}
  //     >
  //       <Paper ref={nodeRef} {...props} />
  //     </Draggable>
  //   );
  // };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      hideBackdrop
      aria-labelledby="model-alerting-dialog-title"
      // PaperComponent={PaperComponent}
      sx={{
        zIndex: Z_INDEX_PRIORITY.MODEL_SETTINGS,
        "& .MuiDialog-container": {
          alignItems: "flex-start",
          justifyContent: "flex-end",
          pt: `${TOP_BAR_HEIGHT + 12}px`,
          pr: "10px",
        },
        "& .MuiPaper-root": {
          width: width ?? 484,
          height: height ?? 760,
          boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
          outline: 0,
          backgroundImage: "none",
          display: "flex",
          flexDirection: "column",
          border: `2px solid ${theme.palette.otherOutlineBorder.main}`,
          backgroundColor: theme.palette.otherBackgroundLight.main,
          borderRadius: "16px",
          transition: "width 250ms ease-in-out 0s",
        },
      }}
    >
      <DialogTitle id="model-alerting-dialog-title" sx={{ p: "1em 1.5em" }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h5" fontWeight={500}>
            {title}
          </Typography>
          <IconButton
            onClick={onClose}
            sx={{ color: theme.palette.text.primary }}
            aria-label="Close"
          >
            <CloseDialogItemIcon />
          </IconButton>
        </Stack>
      </DialogTitle>

      <Divider sx={{ borderColor: theme.palette.otherOutlineBorder.main }} />

      <DialogContent sx={{ p: 0 }}>{children}</DialogContent>
    </Dialog>
  );
};

export default React.memo(DraggedModalBody);
